import styled from 'styled-components'

import {
  color,
  space,
  SpaceProps,
  spacing,
  typography,
} from '../../../../themes'

export const Container = styled.div<SpaceProps>`
  ${space};
  display: flex;
  align-items: start;

  & > div {
    margin-top: 1px;
  }
`

export const RightContent = styled.span`
  ${typography('body2')}
  color: ${color('gray.02')};
  display: block;
  margin-top: 1px;
  margin-left: ${spacing(2.5)};
  overflow: hidden;
`
